import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import { useAtom } from 'jotai';
import { NUMBER_OF_SWATCHES_TO_SHOW } from 'commons/constants';
import useMobileColumnCount from 'components/consumer/ProductListingPage/state/mobileColumnCount/useMobileColumnCount';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import ProductCardStaticPlaceholder from 'components/consumer/ProductCardStaticPlaceholder';
import ProductCardStaticPlaceholderGroup from 'components/consumer/ProductCardStaticPlaceholderGroup';
import { createSearchProductClickHandler } from 'components/consumer/consumer-search/algolia-insights-helpers/createSearchProductClickHandler';
import lastInsightsClickAtom from 'components/consumer/consumer-search/advanced-search/atoms/lastInsightsClickAtom';
import ShowroomDisplayContext from 'components/consumer/category-page-algolia/hooks/ShowroomDisplayContext';
const AdvancedSearchProductsGrid = t0 => {
  const $ = _c(14);
  const {
    products,
    eagerImageCount: t1,
    trailingPlaceholderCount: t2
  } = t0;
  const eagerImageCount = t1 === undefined ? 0 : t1;
  const trailingPlaceholderCount = t2 === undefined ? 0 : t2;
  const mobileColumnCount = useMobileColumnCount();
  const [, setLastInsightsClick] = useAtom(lastInsightsClickAtom);
  const showroomData = useContext(ShowroomDisplayContext);
  let t3;
  if ($[0] !== products) {
    t3 = products?.findIndex(Boolean) ?? -1;
    $[0] = products;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const firstProductIndex = t3;
  let t4;
  if ($[2] !== eagerImageCount || $[3] !== firstProductIndex || $[4] !== products || $[5] !== setLastInsightsClick || $[6] !== showroomData) {
    t4 = !!products && products?.length > 0 && products?.map((product, index) => {
      if (!product) {
        return <ProductCardStaticPlaceholder key={`product-slot-placeholder-${index}`} />;
      }
      const {
        campaign,
        id,
        isClearance,
        isFavorited,
        isHidden,
        label,
        meta,
        name,
        onDisplayInShowroomSlug,
        path,
        position,
        productFamily,
        productLabel,
        productType,
        quickship,
        secondaryImage,
        secondaryImageCropData,
        slug,
        variants,
        variantsToShow,
        variantsTotal,
        moreVariantsCount,
        bypass_stock,
        algoliaMetaData: t5
      } = product;
      const algoliaMetaData = t5 === undefined ? {} : t5;
      return <ProductCardStatic key={`advanced-search-product-${id}-${variantsToShow?.[0]?.sku ?? variants?.[0]?.sku ?? ""}`} campaign={campaign} disableImageLazyLoading={index < eagerImageCount} prioritizeImage={eagerImageCount > 0 && index === firstProductIndex} enableMobileCarousel={true} hidden={isHidden} id={id} isClearance={isClearance} isFavorited={isFavorited} label={label} layout="full" moreVariantsCount={moreVariantsCount ?? variantsTotal - (variantsToShow?.length ?? 0)} name={name} onDisplayInShowroomSlug={onDisplayInShowroomSlug || (showroomData?.productsOnDisplay?.includes(id) ? showroomData.slug : undefined)} path={path} position={position} productFamily={productFamily} productLabel={productLabel} productType={productType} quickship={quickship} secondaryImage={`${secondaryImage}`} secondaryImageCropData={secondaryImageCropData} slug={slug} variants={variants} variantsToShow={variantsToShow?.map(_temp) ?? variants?.slice(0, NUMBER_OF_SWATCHES_TO_SHOW).map(_temp2) ?? []} variantsTotal={variantsTotal} meta={meta} bypass_stock={bypass_stock} onClick={createSearchProductClickHandler(algoliaMetaData, setLastInsightsClick, {
        index,
        productId: id
      })} />;
    });
    $[2] = eagerImageCount;
    $[3] = firstProductIndex;
    $[4] = products;
    $[5] = setLastInsightsClick;
    $[6] = showroomData;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== trailingPlaceholderCount) {
    t5 = trailingPlaceholderCount > 0 && <ProductCardStaticPlaceholderGroup count={trailingPlaceholderCount} />;
    $[8] = trailingPlaceholderCount;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== mobileColumnCount || $[11] !== t4 || $[12] !== t5) {
    t6 = <div className="md:space-y-8 md:mb-8 md:flex-1 min-h-[400px]"><ProductCardGridUI limitWidth={false} columnsOnDesktop="auto" columnsOnMobile={mobileColumnCount}>{t4}{t5}</ProductCardGridUI></div>;
    $[10] = mobileColumnCount;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default AdvancedSearchProductsGrid;
function _temp(variant_0) {
  return {
    ...variant_0,
    image: `${variant_0?.image}`
  };
}
function _temp2(variant) {
  return {
    ...variant,
    image: `${variant?.image}`
  };
}